import React from 'react';
import { ArrowLeftIcon } from 'icons';
import { GetStaticProps } from 'next';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { formatSubject, TestMain } from 'modules/dtm';
import { globalConst } from 'modules/global';

import { NextHead } from 'components';

const Index = () => {
  const t = useTranslations();
  const { query } = useRouter();

  return (
    <>
      <NextHead
        title={t('meta.dtm_subject.title', { subject: formatSubject((query?.test as string)) })}
        description={t('meta.dtm_subject.description', {
          subject: formatSubject((query?.test as string))
        })}
      />

      <div className="max-w-screen mx-auto my-9 min-h-screen p-3 lg:p-0">
        <Link href={globalConst.pageNames.DTM}>
          <div className="m-4 inline-flex cursor-pointer items-center justify-start gap-2 font-semibold sm:m-0">
            <ArrowLeftIcon /> {t('common.ortga_qaytish')}
          </div>
        </Link>
        <TestMain />
      </div>
    </>
  );
};

export default Index;

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    messages: (await import(`../../messages/${locale}.json`)).default
  }
});

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: 'blocking'
  };
}
